import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * useTimer - a simple countdown timer hook
 * @param initialSeconds - initial seconds for the timer
 * @returns [secondsLeft, startTimer, resetTimer]
 */
export function useTimer(initialSeconds: number = 30): [number, () => void, () => void] {
  const [secondsLeft, setSecondsLeft] = useState(0)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const startTimer = useCallback(() => {
    setSecondsLeft(initialSeconds)
  }, [initialSeconds])

  const resetTimer = useCallback(() => {
    setSecondsLeft(0)
  }, [])

  useEffect(() => {
    if (secondsLeft > 0) {
      timerRef.current = setTimeout(() => setSecondsLeft((s) => s - 1), 1000)
    } else if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [secondsLeft])

  return [secondsLeft, startTimer, resetTimer]
}
